export default __webpack_public_path__ + "static/media/BasicVerfication.2456adc2.svg";